import { styled, Typography } from "@mui/material";
import React from "react";
import digitalBoothImage from "../../assets/EarthStation/Digital&Physical_Booths.svg";
import interativeZoneImage from "../../assets/EarthStation/Interactive_Zones.svg";
import volunteerImage from "../../assets/EarthStation/Volunteer.svg";
import banner from "../../assets/EarthStation/Earth_Station_Banner.png";
import volunteer_banner from "../../assets/EarthStation/Volunteer_Banner.svg";
import earthStationIcon from "../../assets/EarthStation/Earth_station_green.svg";
import theme from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import { URL_ROUTES } from "../../routes/UrlList";

const ActivityList = [
  {
    title: "Interactive Zones",
    image: interativeZoneImage,
    desc: "Explore download zones with live progress screens, upcycling booths, and earn Sustainability Certificates throughout the 3-6 week campaign.",
  },
  {
    title: "Digital & Physical Booths",
    image: digitalBoothImage,
    desc: "Visit booths across India and overseas offices, encouraging friendly download competitions between branches and business units.",
  },
  {
    title: "Volunteers",
    image: volunteerImage,
    desc: "We’re seeking volunteers, especially trainees and unallocated teams from India and abroad, to support this exciting campaign",
  },
];

const EarthStation = () => {
  const navigate = useNavigate();
  return (
    <Container sx={{ maxWidth: "100vw", padding: "none" }}>
      <EarthStationBannerContainer>
        <EarthStationContent>
          <img src={earthStationIcon} alt="earth station" height="100px" />
          <Typography
            variant="body1"
            align="center"
            sx={{
              color: "#fff",
            }}
          >
            WELCOME TO
          </Typography>
          <Typography
            variant="h3"
            align="center"
            sx={{
              mb: 2,
              color: "#fff",
              fontFamily: "Houschka Rounded Alt",
            }}
          >
            Earth Station
          </Typography>
          <Typography
            variant="body2"
            textAlign="center"
            sx={{ color: "#fff", display: { xs: "none", sm: "flex" } }}
          >
            Earth Station is a campaign to inflate a 5 meter Earth with each
            Circle4Life app download. Help us reach 100K downloads! Join
            interactive zones with live counts, upcycling booths, and earn
            Sustainability Certificates. Volunteers from India and abroad lets
            unite for a sustainable future!
          </Typography>
        </EarthStationContent>
        <EarthStationBanner src={banner} alt="Earth station Banner" />
      </EarthStationBannerContainer>
      <ActivitySection>
        {ActivityList.map((activity) => (
          <ActivityCard key={activity.title}>
            <div className="media">
              <img src={activity.image} alt={activity.title} />
            </div>
            <Typography
              variant="h4"
              align="center"
              sx={{
                mb: 2,
                color: "#4a4a4a",
                fontWeight: "600",
                fontFamily: "Houschka Rounded Alt",
              }}
            >
              {activity.title}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={theme.typography.fontWeightRegular}
              align="center"
              color="text.secondary"
            >
              {activity.desc}
            </Typography>
          </ActivityCard>
        ))}
      </ActivitySection>
      <VolunteerBannerContainer>
        <VolunteerContent>
          <Typography
            variant="h4"
            align="center"
            sx={{
              mb: 2,
              color: "#4a4a4a",
              fontWeight: "600",
              fontFamily: "Houschka Rounded Alt",
            }}
          >
            Join us & let’s
          </Typography>
          <Typography
            variant="h4"
            align="center"
            sx={{
              mb: 2,
              color: "#4a4a4a",
              fontWeight: "600",
              fontFamily: "Houschka Rounded Alt",
            }}
          >
            #InflateTheEarth
          </Typography>
          <VolunteerButton
            onClick={() => {
              navigate(URL_ROUTES.VOLUNTEER);
            }}
          >
            <Typography>Join as Volunteer</Typography>
          </VolunteerButton>
        </VolunteerContent>
        <VolunteerBanner src={volunteer_banner} alt="Volunteer banner" />
      </VolunteerBannerContainer>
    </Container>
  );
};

export default EarthStation;

const Container = styled("div")({
  // maxWidth: "1200px",
  // margin: "0 auto",
  // padding: "24px",
});

const EarthStationBannerContainer = styled("div")({
  position: "relative",
});

const EarthStationBanner = styled("img")({
  width: "100%",
  height: "auto",
  display: "block",
});

const EarthStationContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: "40px",
  left: "50%",
  transform: "translateX(-50%)",

  "@media (max-width: 768px)": {
    // position: "relative",
    width: "100%",
    top: "5px",
  },
});

const ActivitySection = styled("div")({
  display: "flex",
  padding: "20px",
  gap: "30px",
  "@media (max-width: 768px)": {
    flexDirection: "column",
  },
});

const ActivityCard = styled("div")({
  flex: 1,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  "& .media": {
    height: "120px",
  },
});

const VolunteerBannerContainer = styled("div")({
  position: "relative",
});

const VolunteerContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: "20px",
  left: "50%",
  transform: "translateX(-50%)",

  "@media (max-width: 768px)": {
    position: "relative",
    padding: "20px",
  },
});

const VolunteerButton = styled("button")({
  border: "none",
  padding: "10px",
  background: "linear-gradient(90deg,#3986C8,#14B44C)",
  borderRadius: "6px",
  color: "#fff",
  cursor: "pointer",
});

const VolunteerBanner = styled("img")({
  width: "100%",
  height: "auto",
  display: "block",

  "@media (max-width: 768px)": {
    display: "none",
  },
});
